// extracted by mini-css-extract-plugin
module.exports = {"wrap":"OrdersList_wrap__2oE8I","brandCell":"OrdersList_brandCell__3tjGa"};